import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import orderApi from "../api/orderApi";

// create slice
const name = "order";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const orderActions = { ...slice.actions, ...extraActions };
export const orderReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    lstOrder: [],
    totalCountOrder: 0,
  };
}

function createExtraActions() {
  return {
    getOrders: getOrders(),
  };

  function getOrders() {
    return createAsyncThunk(
      `${name}/getOrders`,
      async (params) => await orderApi.getOrders(params)
    );
  }
}

function createExtraReducers() {
  return {
    ...getOrders(),
  };

  function getOrders() {
    const { pending, fulfilled, rejected } = extraActions.getOrders;
    return {
      [pending]: (state) => {
        state.lstOrder = [];
      },
      [fulfilled]: (state, action) => {
        const data = action.payload;
        state.lstOrder = data.results;
        state.totalCountOrder = data.totalResults;
      },
      [rejected]: (state, action) => {
        state.lstOrder = [];
      },
    };
  }
}
